export const BORDER_ORANGE = '#FCA700';
export const BORDER_GREEN = '#6A9A23';
export const BORDER_BLUE = '#1868DB';
export const BORDER_PURPLE = '#AF59E0';
